const CATALOG_IMAGE_RESOLVE_TYPES = new Set(['CATALOG_IMAGE_RESOLVE_ACTIVE', 'CATALOG_IMAGE_RESOLVE_COMPLETED']);

export function isCatalogImageResolveInboxType(type: string): boolean {
  return CATALOG_IMAGE_RESOLVE_TYPES.has(type);
}
